/**
 * A custom error class for known errors that occur in the portal. This is primarily
 * used to provide a more concise error message to the user, without relying on the
 * underlying details of the error itself.
 */
export class PortalError extends Error {
  public readonly code: PortalErrorCode

  constructor(
    code: PortalErrorCode,
    message: string,
    public readonly originalError?: Error,
  ) {
    super(message)
    this.name = 'PortalError'
    this.code = code
  }
}

export type PortalErrorCode =
  | 'BIG_PEER_CONNECTION_ERROR'
  | 'RELAY_FETCH_FAILED'
  | 'UNKNOWN'

export const CODE_TO_HEADER: Record<PortalErrorCode, string> = {
  BIG_PEER_CONNECTION_ERROR: 'Big Peer connection error',
  RELAY_FETCH_FAILED: 'There was a connection error with the server',
  UNKNOWN: 'Something went wrong',
}

export const CODE_TO_MESSAGE: Record<PortalErrorCode, string> = {
  BIG_PEER_CONNECTION_ERROR:
    'We can’t reach the big peer for your app right now. We have been notified and will investigate. Please check back later.',
  RELAY_FETCH_FAILED:
    'We are having trouble connecting. Please try again later.',
  UNKNOWN: 'An unexpected error occurred. Please try again later.',
}
